import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Alert } from "PFComponents/alert";
import { Button } from "PFComponents/button";
import { Modal } from "PFComponents/modal";
import { Typography } from "PFComponents/typography";
import { isDatePassed } from "PFCore/helpers/date";
import { getProfileName } from "PFCore/helpers/profile";
import { useActivityReviewComplete } from "PFCore/hooks/queries/activity/use_activity_review_complete";
import { useErrorsGrowl } from "PFCore/hooks/use_errors_growl";
import { useTranslation } from "react-i18next";
import { useToggle } from "react-use";

import { useActivityShortlists } from "../../hooks/use_activity_shortlists";
import { useCurrentActivity } from "../../hooks/use_current_activity";
import { ReviewDeadlineLabel } from "./review_deadline_label";
import css from "./review_section.module.scss";
import { ReviewerLabel } from "./reviewer_label";

export const ReviewerFlow = () => {
  const growlErrors = useErrorsGrowl();
  const { showGrowl } = useGrowlStoreActions();

  const { t } = useTranslation("activities", { keyPrefix: "show.shortlist.review" });
  const activity = useCurrentActivity();
  const { allShortlists } = useActivityShortlists();
  const { mutate: completeReview } = useActivityReviewComplete({
    onSuccess: () => {
      showGrowl({ message: t("reviewSubmitted") });
    },
    onError: (error) => {
      growlErrors(error);
    }
  });

  const [showModal, toggleShowModal] = useToggle(false);
  const deadlineDate = activity.review?.deadline;
  const deadlinePassed = isDatePassed(deadlineDate);
  const completedDate = activity.review?.completed_at;
  const reviewer = activity.review?.completed_by;

  const canComplete = !!allShortlists.find((shortlist) => ["accepted", "declined"].includes(shortlist.state));

  const handleSubmit = () => {
    completeReview({ id: activity.id });
  };

  const renderContent = () => (
    <>
      {completedDate ? (
        <ReviewerLabel name={getProfileName(reviewer)} date={completedDate} />
      ) : (
        deadlinePassed && <Alert className={css.label} title={t("deadlinePassed")} kind="warning" />
      )}
      <Button
        className={css.button}
        onClick={toggleShowModal}
        text={t("submitReview")}
        disabled={!canComplete}
        qaId="ActivityPageCompleteReviewButton"
      />
    </>
  );

  return (
    <>
      {deadlineDate && !completedDate && <ReviewDeadlineLabel date={deadlineDate} />}
      {renderContent()}
      {showModal && (
        <Modal title={t("submitReview")} onOK={handleSubmit} onClose={toggleShowModal}>
          <Typography withMargin variant="bodyRegular">
            {t("submitConfirmMessage")}
          </Typography>
        </Modal>
      )}
    </>
  );
};
